import React, { useEffect, useState } from 'react';
import axios from '../../axios';
import { Table, Button, Modal, Alert } from 'react-bootstrap';
import MajorModal from './MajorModal';
import { useNavigate } from 'react-router-dom';

const ManageMajors = () => {
    const [majors, setMajors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedMajor, setSelectedMajor] = useState(null);
    const [currentAcademicYear, setCurrentAcademicYear] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate(); // useNavigate hook để điều hướng

    useEffect(() => {
        fetchCurrentAcademicYearAndMajors();
    }, []);

    const fetchCurrentAcademicYearAndMajors = async () => {
        try {
            const res = await axios.get('/majors');
            if (res.data.currentAcademicYear) {
                setCurrentAcademicYear(res.data.currentAcademicYear);
                setMajors(res.data.majors);
            } else {
                // Redirect to the configuration page if current academic year is not found
                navigate('/configurations');
            }
        } catch (err) {
            setError('Error fetching data. Please try again.');
            console.error(err);
        }
    };

    const handleShowModal = (major = null) => {
        setSelectedMajor(major);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedMajor(null);
        fetchCurrentAcademicYearAndMajors();
    };

    const handleManageClasses = (majorId) => {
        navigate(`/manage-classes/${majorId}`); // Điều hướng đến trang quản lý lớp của ngành
    };

    const handleGenerateClasses = async (majorId) => {
        try {
            await axios.post(`/majors/generate-classes/${majorId}`);
            fetchCurrentAcademicYearAndMajors(); // Refresh the list after generating classes
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <h2>Quản lý Ngành / Mở lớp năm tuyển sinh {currentAcademicYear}</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Button variant="primary" onClick={() => handleShowModal()}>
                Thêm Ngành
            </Button>
            <Table striped bordered hover className="mt-4">
                <thead>
                    <tr>
                        <th>Mã Ngành</th>
                        <th>Tên Ngành</th>
                        <th>Số lớp dự kiến mở</th>
                        <th>Số lớp thực tế</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {majors.map(major => (
                        <tr key={major._id}>
                            <td>{major.majorCode}</td>
                            <td>{major.majorName}</td>
                            <td>{major.expectedClassCount}</td>
                            <td>{major.actualClassCount}</td>
                            <td>
                                <Button
                                    variant="primary"
                                    onClick={() => handleManageClasses(major._id)} // Gọi hàm quản lý lớp
                                    className="mr-2"
                                >
                                    Quản lý lớp
                                </Button>
                                {major.actualClassCount === 0 && (
                                    <Button
                                        variant="warning"
                                        onClick={() => handleGenerateClasses(major._id)} // Gọi hàm sinh lớp
                                        className="mr-2"
                                    >
                                        Sinh lớp tự động
                                    </Button>
                                )}
                                <Button
                                    variant="info"
                                    onClick={() => handleShowModal(major)}
                                >
                                    Sửa
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {showModal && (
                <MajorModal
                    show={showModal}
                    onHide={handleCloseModal}
                    currentAcademicYear={currentAcademicYear}
                    major={selectedMajor}
                />
            )}
        </div>
    );
};

export default ManageMajors;
